import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';

export function useScrollAnimation() {
    // Configuration object to define the sections and thresholds
    const config = {
        howItWorksId: '#howItWorksSection',
        secondSectionId: '#bottomSection',
        stepHeightAdjustment: 400,
        stepThresholds: {
            first: 400,
            second: 700,
        },
    };

    const store = useStore();
    const loading = computed(() => store.state.loading);
    const isMobile = computed(() => store.state.device.isMobile);

    const active = ref(0);
    const activeStep = ref(1);
    const sectionHowItWorksOffset = ref(null);
    const sectionSecondOffset = ref(null);
    const reducedConstant = ref(400);

    const calcOffsets = () => {
        if (!loading.value) {
            setTimeout(() => {
                const sectionHowItWorks = document.querySelector(
                    config.howItWorksId
                );
                const secondSection = document.querySelector(
                    config.secondSectionId
                );

                if (sectionHowItWorks && secondSection) {
                    sectionHowItWorksOffset.value =
                        sectionHowItWorks.getBoundingClientRect().top +
                        window.scrollY;
                    sectionSecondOffset.value =
                        secondSection.getBoundingClientRect().top +
                        window.scrollY;

                    if (isMobile.value) {
                        reducedConstant.value = 200;
                    }
                }
            }, 1000);
        }
    };

    const calcActiveStep = () => {
        const stepHeight =
            (sectionSecondOffset.value - sectionHowItWorksOffset.value) / 3;
        const adjustment = config.stepHeightAdjustment || 400;
        const thresholds = config.stepThresholds || { first: 400, second: 700 };

        if (
            window.top.scrollY <
            sectionHowItWorksOffset.value + stepHeight - adjustment
        ) {
            activeStep.value = 1;
        } else if (
            window.top.scrollY >
                sectionHowItWorksOffset.value + stepHeight - thresholds.first &&
            window.top.scrollY <
                sectionHowItWorksOffset.value +
                    stepHeight * 2 -
                    thresholds.second
        ) {
            activeStep.value = 2;
        } else if (
            window.top.scrollY >
            sectionHowItWorksOffset.value + stepHeight * 2 - thresholds.second
        ) {
            activeStep.value = 3;
        }
    };

    const handleScroll = () => {
        const currentScroll = window.top.scrollY;
        const howItWorksThreshold =
            sectionHowItWorksOffset.value - reducedConstant.value;
        const adapterThreshold =
            sectionSecondOffset.value - reducedConstant.value;

        if (currentScroll > adapterThreshold) {
            active.value = 6;
        } else if (currentScroll > howItWorksThreshold) {
            active.value = 5;
            calcActiveStep();
        }
    };

    onMounted(() => {
        calcOffsets();
        window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
    });

    watch(loading, (newVal) => {
        if (!newVal) {
            calcOffsets();
        }
    });

    return {
        active,
        activeStep
    };
}
